// extracted by mini-css-extract-plugin
export default {"layout-tile-l":"J9m3u"};